// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import DonationController from "./donation_controller"
application.register("donation", DonationController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)
